import { DesktopGridItem } from 'shared/types/desktop-grid'

/**
 * Creates a 2D grid array to track occupied slots
 */
export const createGrid = (rows: number, cols: number): boolean[][] =>
  Array.from({ length: rows }, () => Array(cols).fill(false))

/**
 * Sorts items by area (largest first), then by position (row, col), then by id
 */
export const sortItemsByAreaAndPosition = (
  items: DesktopGridItem[]
): DesktopGridItem[] => {
  return [...items].sort((a, b) => {
    const areaA = a.size.width * a.size.height
    const areaB = b.size.width * b.size.height
    if (areaA !== areaB) {
      return areaB - areaA
    }
    if (a.position.row !== b.position.row) {
      return a.position.row - b.position.row
    }
    if (a.position.col !== b.position.col) {
      return a.position.col - b.position.col
    }
    return a.id.localeCompare(b.id)
  })
}

/**
 * Checks if a slot of given dimensions fits at the specified position
 */
export const checkSlotFits = (
  grid: boolean[][],
  row: number,
  col: number,
  width: number,
  height: number,
  rows: number,
  cols: number
): boolean => {
  if (row + height > rows || col + width > cols) return false

  for (let r = row; r < row + height; r += 1) {
    for (let c = col; c < col + width; c += 1) {
      if (grid[r][c]) return false
    }
  }
  return true
}

/**
 * Marks a slot as occupied in the grid
 */
export const markSlotOccupied = (
  grid: boolean[][],
  row: number,
  col: number,
  width: number,
  height: number
): void => {
  for (let r = row; r < row + height; r += 1) {
    for (let c = col; c < col + width; c += 1) {
      grid[r][c] = true
    }
  }
}
